import { secureApi } from './secureApi';

// Thin wrapper over the existing backend alert endpoints.
// GET /api/v1/alerts?resolved=<bool>   → { alerts: [...] } (populated: alertType, alertStatus, alertPriority, property)
// PUT /api/v1/alerts/:alertId/resolve  → { message, alert }   (sets resolved=true, resolved_by, resolved_at)
const alertApi = {
  getAlerts: async ({ resolved } = {}) => {
    const params = {};
    if (resolved !== undefined) params.resolved = String(resolved);
    const response = await secureApi.get('/api/v1/alerts', { params });
    return response.data;
  },

  resolveAlert: async (alertId) => {
    const response = await secureApi.put(`/api/v1/alerts/${alertId}/resolve`);
    return response.data;
  },

  // Phase 2 lock-ops plumbing: ownership.
  // PUT /:alertId/claim   → 200 { alert } | 409 already claimed/resolved
  // PUT /:alertId/release → 200 { alert } | 409 not owner
  claimAlert: async (alertId) => {
    const response = await secureApi.put(`/api/v1/alerts/${alertId}/claim`);
    return response.data;
  },

  releaseAlert: async (alertId) => {
    const response = await secureApi.put(`/api/v1/alerts/${alertId}/release`);
    return response.data;
  }
};

export default alertApi;
